/**
 * Auto-generated from dark-roast/api-envoy OpenAPI spec. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Api } from '@axiom/ui';



import { type CreateAuthRefreshTokenRequest } from './dtos/create-auth-refresh-token-request';
import { type CreateAuthRequest } from './dtos/create-auth-request';
import { type CreateAuthResetResponse } from './dtos/create-auth-reset-response';
import { type CreateAuthResetsRequest } from './dtos/create-auth-resets-request';
import { type CreateAuthResetsResponse } from './dtos/create-auth-resets-response';
import { type ReadAuthResetResponse } from './dtos/read-auth-reset-response';
import { type ReadAuthResponse } from './dtos/read-auth-response';
import { type UpdateAuthResetRequest } from './dtos/update-auth-reset-request';
import { type UpdateAuthResetResponse } from './dtos/update-auth-reset-response';
import { EnvUtil } from '../../utils/env-util';

class AuthApiClass extends Api {
  constructor() {
    super({ domain: EnvUtil.apiEnvoyUrl });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /auth
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: AuthController.postAuth — POST /auth */
  createAuth({ body }: { body: CreateAuthRequest }) {
    return super.write<UpdateAuthResetResponse>({
      endpoint: '/auth',
      method: 'POST',
      body,
    });
  }

  /** Java: LegacyAuthController.getAuthForEmail — GET /auth/{email} */
  readAuth({ email, query }: { email: string; query: { "RelayState"?: string } }) {
    return super.read<{ "data": ReadAuthResponse }>({
      endpoint: `/auth/${email}`,
      method: 'GET',
      query,
    });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /auth/refreshToken
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: AuthController.postAuthRefreshToken — POST /auth/refreshToken */
  createAuthRefreshToken({ body }: { body: CreateAuthRefreshTokenRequest }) {
    return super.write<UpdateAuthResetResponse>({
      endpoint: '/auth/refreshToken',
      method: 'POST',
      body,
    });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /auth/resets
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: AuthController.createAuthReset — POST /auth/resets */
  createAuthResets({ body }: { body: CreateAuthResetsRequest }) {
    return super.write<CreateAuthResetsResponse>({
      endpoint: '/auth/resets',
      method: 'POST',
      body,
    });
  }

  /** Java: AuthController.getAuthResetToken — GET /auth/resets/{id} */
  readAuthReset({ id }: { id: string }) {
    return super.read<{ "data": ReadAuthResetResponse }>({
      endpoint: `/auth/resets/${id}`,
      method: 'GET',
    });
  }

  /** Java: AuthController.postAuthResetToken — POST /auth/resets/{id} */
  createAuthReset({ id }: { id: string }) {
    return super.write<{ "data": CreateAuthResetResponse }>({
      endpoint: `/auth/resets/${id}`,
      method: 'POST',
    });
  }

  /** Java: AuthController.patchAuthResetToken — PATCH /auth/resets/{id} */
  updateAuthReset({ id, body }: { id: string; body: UpdateAuthResetRequest }) {
    return super.write<UpdateAuthResetResponse>({
      endpoint: `/auth/resets/${id}`,
      method: 'PATCH',
      body,
    });
  }

  /*
   * ────────────────────────────────────────────────────────────────────
   *   /auth/tokenLogin/{id}
   * ────────────────────────────────────────────────────────────────────
   */

  /** Java: LegacyAuthController.patchAuthTokenLogin — PATCH /auth/tokenLogin/{id} */
  updateAuthTokenLogin({ id }: { id: string }) {
    return super.write<UpdateAuthResetResponse>({
      endpoint: `/auth/tokenLogin/${id}`,
      method: 'PATCH',
    });
  }
}

export const AuthApi = new AuthApiClass();
export type { AuthApiClass };
